module.exports = __webpack_public_path__ + "static/img/recruit_2024_ttl.0af67a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/recruit_2024_ttl.png
// module id = QUcd
// module chunks = 0